import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import TextOptions from "%/dynamic-component-editor/bundles/text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import {
  TextElementMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/text-element-mixin";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import BorderOptions from "%/dynamic-component-editor/bundles/border-options";
import ClickAction from "%/dynamic-component-editor/options/click-action";
import TypographyBranding from "%/dynamic-component-editor/classes/branding/typography-branding";

export const StaticBrandedTextElementMixin = {
  mixins: [DynamicElementMixin, TextElementMixin],
  brandingType: TypographyBranding,
  optionBundles: [
    AppearanceOptions,
    new LayoutWidthHeightOptions({}, {
      "max-height": true,
      "min-height": true,
    }),
    new BrandedTextStyleOptions({
      "default.text-branding-style-option": "paragraph",
    }, {
      "text-option": true,
    }),
    BasicTextOptions,
    TextOptions,
    SpacingOptions,
    EffectsOptions,
    BorderOptions,
    new BackgroundOptions({}, {
      "background-image": true,
      "background-gradient": true,
    }),
  ],
  options: [
    ClickAction,
  ],
  computed: {
    isEditable() {
      return true;
    },
    value() {
      return "";
    },
    shouldShowText() {
      return true;
    },
  },
  methods: {
    setDefaultBrandingValue() {
      // override text element mixin method to avoid adding text branding store
    },
  },
};
